import { type IFileState } from "@/interfaces";
import { type FileCategory } from "@/types";

export default (
  content: string,
  type: FileCategory = "document",
  id?: string,
  isFavorite?: boolean,
): IFileState => {
  return {
    id,
    base64: content,
    name: "",
    type,
    isFavorite,
  };
};
